import { Component, computed, input, output, signal, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FileObject, PersonGridItemObject, ServiceTypeGridItemObject } from '@it2go/types';
import { PersonEditBasicInfoStore } from './person-edit-basic-info.store';
import { ServiceTypeEnum } from '@libs/types/src/services/enum/service-type.enum';
import { CardComponent } from '../../../../../components/kit/card/card.component';
import { InputFileBtnComponent } from '../../common/input-file-btn/input-file-btn.component';
import { PersonInitialsPipe } from '../../../../shared/pipes/personInitials';
import { DeleteButtonComponent } from '../../../../../components/kit/button/delete-button.component';
import {
    SelectButtonSexInputComponent,
} from '../../../../../components/kit/input/select-button-input/select-button-sex-input.component';
import { SelectInputComponent } from '../../../../../components/kit/input/select-input/select-input.component';
import { TextInputComponent } from '../../../../../components/kit/input/text-input/text-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { SERVICE_SETTINGS_DIET_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import { TextAreaInputComponent } from '../../../../../components/kit/input/text-area-input/text-area-input.component';
import { AvatarComponent } from '../../../../shared/components/kit/avatar/avatar.component';

@Component({
    selector: 'app-person-edit-basic-info',
    templateUrl: './person-edit-basic-info.component.html',
    providers: [PersonEditBasicInfoStore],
    imports: [
        CardComponent,
        InputFileBtnComponent,
        PersonInitialsPipe,
        DeleteButtonComponent,
        SelectButtonSexInputComponent,
        SelectInputComponent,
        TextInputComponent,
        TranslatePipe,
        TextAreaInputComponent,
        AvatarComponent,
    ],
})
export class PersonEditBasicInfoComponent {
    protected readonly store = inject(PersonEditBasicInfoStore);


    public form = input.required<FormGroup>();
    public person = input<PersonGridItemObject | null>(null);
    public canEdit = input(false);
    public serviceType = input<ServiceTypeGridItemObject | null>(null);

    public newFile = signal<string | null>(null);
    public isSocial = computed(() => {
        return this.serviceType()?.type === ServiceTypeEnum.SOCIAL;
    });
    public isHealthCare = computed(() => {
        return this.serviceType()?.type === ServiceTypeEnum.HEALTH_CARE;
    });
    // TODO same condition under person-basic-info, but checking name is terrible also is terrible copy-paste prone to err
    showInsuranceNumber = computed(() => {
        return this.isHealthCare()
            || (this.isSocial()
                && (this.serviceType()?.name === 'Domovy pro seniory'
                    || this.serviceType()?.name === 'Domovy se zvláštním režimem')
            );
    });

    protected useDiet = computed(() => {
        const social = this.isSocial();
        const allowed = this.store.globalGlobalStore.organizationStore.getServiceSetting(this.store.globalGlobalStore.loggedUserStore.selectedServiceId() || 0, SERVICE_SETTINGS_DIET_TYPE_KEY)?.useCard ?? true;

        return social && allowed;
    })

    public uploaded = output<string>();

    public onFileUpload(file: FileObject): void {
        if (this.person() && this.person()?.id) {
            this.store.api.updatePerson({
                personId: this.person()!.id,
                image: file.name,
            });
        } else {
            this.newFile.set(file.name);
        }
        this.uploaded.emit(file.name);
    }

    protected async deleteImage(): Promise<void> {
        if (!this.person()?.image) return;

        await Promise.all([
            this.store.api.deleteFile({
                path: this.person()!.image || '',
            }),
            this.store.api.updatePerson({
                personId: this.person()!.id,
                image: null,
            }),
        ]);
    }

}
